/* eslint-disable func-names, vars-on-top, no-var */
window.intercomSettings = {
  app_id: import.meta.env.VITE_INTERCOM,
};
function launch() {
  const w = window; const ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
    return Promise.resolve();
  }
  const d = document;
  // eslint-disable-next-line prefer-rest-params
  var i = function () { i.c(arguments); };
  i.q = [];
  i.c = function (args) { i.q.push(args); };
  w.Intercom = i;
  const l = function () {
    const s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${import.meta.env.VITE_INTERCOM}`;
    const x = d.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
    return Promise.resolve();
  };
  return l();
}

export default launch;
